import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import RegisterModal from './RegisterModal';
import BadgeCheckinModal from './BadgeCheckinModal';
import BadgeActionModal from './BadgeActionModal';
import DeviceActivation from './DeviceActivation';
import LanguageSwitcher from './LanguageSwitcher';
import { api } from '../api/client';
import { useLanguage } from '../i18n/LanguageContext';
import { APP_VERSION } from '../version';
import '../styles/kiosk.css';

export default function UserPanel() {
  const [activeModal, setActiveModal] = useState(null); // 'register' | 'badge' | 'uscita' | null
  const [licenseValid, setLicenseValid] = useState(null); // null = in verifica
  const [deviceAuthorized, setDeviceAuthorized] = useState(null); // null = in verifica
  const [adminLinkVisible, setAdminLinkVisible] = useState(true);
  const { t } = useLanguage();

  const checkDeviceStatus = () => {
    api.getDeviceStatus()
      .then((res) => setDeviceAuthorized(!res.authRequired || res.authorized))
      .catch(() => setDeviceAuthorized(true)); // in caso di errore non blocca il kiosk
  };

  useEffect(() => {
    api.getLicenseStatus()
      .then((res) => setLicenseValid(res.valid))
      .catch(() => setLicenseValid(false));

    api.getKioskConfig()
      .then((res) => setAdminLinkVisible(res?.data?.adminLinkVisible !== false))
      .catch(() => setAdminLinkVisible(true));

    checkDeviceStatus();
  }, []);

  if (licenseValid === null || deviceAuthorized === null) return <div className="kiosk" />;

  if (!licenseValid) {
    return (
      <div className="kiosk">
        <div className="kiosk-header">
          <div className="logo-frame">
            <Logo size={44} />
          </div>
        </div>
        <p style={{ color: 'var(--muted-text)', maxWidth: 360, textAlign: 'center' }}>
          Il servizio non è ancora attivo su questo dispositivo. Contatta l'amministratore.
        </p>
        {/* Il link resta sempre visibile qui, a prescindere dall'impostazione:
            senza licenza è l'unica via per raggiungere l'attivazione. */}
        <Link to="/admin" className="kiosk-footer-link">{t('adminLink')}</Link>
        <span className="kiosk-version">ExelFlow v{APP_VERSION}</span>
      </div>
    );
  }

  if (!deviceAuthorized) {
    return <DeviceActivation onActivated={checkDeviceStatus} />;
  }

  return (
    <div className="kiosk">
      <LanguageSwitcher />

      <div className="kiosk-header">
        <div className="logo-frame">
          <Logo size={44} />
        </div>
        <span className="kiosk-subtitle">{t('kioskSubtitle')}</span>
      </div>

      <div className="kiosk-grid">
        <button className="kiosk-button kiosk-button--register" onClick={() => setActiveModal('register')}>
          <span className="icon-badge" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20c0-3.5 3.5-6 8-6s8 2.5 8 6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/></svg>
          </span>
          {t('btnRegister')}
        </button>

        <button className="kiosk-button kiosk-button--badge" onClick={() => setActiveModal('badge')}>
          <span className="icon-badge" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><rect x="5" y="4" width="14" height="17" rx="2" stroke="#fff" strokeWidth="1.8"/><circle cx="12" cy="10" r="2.2" stroke="#fff" strokeWidth="1.6"/><path d="M8.5 16h7" stroke="#fff" strokeWidth="1.6" strokeLinecap="round"/></svg>
          </span>
          {t('btnBadge')}
        </button>

        <button className="kiosk-button kiosk-button--exit" onClick={() => setActiveModal('uscita')}>
          <span className="icon-badge" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3M10 8l-4 4 4 4M6 12h12" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </span>
          {t('btnExit')}
        </button>
      </div>

      {adminLinkVisible && <Link to="/admin" className="kiosk-footer-link">{t('adminLink')}</Link>}
      <span className="kiosk-version">ExelFlow v{APP_VERSION}</span>

      {activeModal === 'register' && <RegisterModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'badge' && <BadgeCheckinModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'uscita' && <BadgeActionModal action="uscita" onClose={() => setActiveModal(null)} />}
    </div>
  );
}
